import { render, staticRenderFns } from "./crearRompecabezas_docente.vue?vue&type=template&id=947f6182"
import script from "./crearRompecabezas_docente.vue?vue&type=script&lang=js"
export * from "./crearRompecabezas_docente.vue?vue&type=script&lang=js"
import style0 from "./crearRompecabezas_docente.vue?vue&type=style&index=0&id=947f6182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports